// Funcao para extrair valores únicos de um array de objetos com base em uma chave específica
// Remover null, undefined e strings vazias e ordenar os valores alfabeticamente
// O resultado é um array de objetos únicos, contendo os campos label e value, onde também é possível passar uma segunda chave para o valor (valueKey)
// Exemplo de uso: ExtractUniqueValues(data, 'NOME', 'CPF') => [{ label: 'João', value: '12345678900' }, { label: 'Maria', value: '98765432100' }]


const ExtractUniqueValues = (data, labelKey, valueKey = null) => {

    const uniqueValuesSet = new Set();
    const uniqueValuesArray = [];

    data.forEach(item => {
        const label = item[labelKey];
        const value = valueKey ? item[valueKey] : label;
        if (label !== null && label !== undefined && label !== '') {
            const uniqueIdentifier = `${label}-${value}`;
            if (!uniqueValuesSet.has(uniqueIdentifier)) {
                uniqueValuesSet.add(uniqueIdentifier);
                uniqueValuesArray.push({ label, value });
            }
        }
    });

    // Ordenar alfabeticamente pelo label
    uniqueValuesArray.sort((a, b) => a.label.localeCompare(b.label));

    return uniqueValuesArray;

}

export default ExtractUniqueValues;